<template>
    <div class="container-fluid">
        <section class="content-header">
                <div class="row mb-2">
                    <h3 v-if="(no_factura==1 || sistema_verifactu==1) && verifactu==0">{{ $t('general.lineasregistro') }}</h3>
                    <h3 v-if="no_factura==0 && sistema_verifactu==0">{{ $t('general.lineasfacturacion') }}</h3>
                    <h3 v-if="verifactu==1">{{ $t('general.lineasverifactu') }}</h3>
                </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-2">
                    <lineasfacturacion-estados 
                        :activos="activos" 
                        :eliminados="eliminados" 
                        @cambiar-activos="cambiaractivos"
                        @cambiar-eliminados="cambiareliminados" 
                    />
                </div>
                <div class="col-md-10">
                    <!--<tabla-datos 
                        v-if="tablaLista"
                        :columnas="columnas" 
                        :datos="datos" 
                        :filters="clonarFiltros(filtros)" 
                        :filtrosBuscador="filtrosBuscador"
                        :total="total"
                        @filter="onTablaFilter"
                        @quieroDatos="obtenerDatos($event)"
                        >
                    </tabla-datos>-->
                    <div class="card">
                        <div class="card-body" style="padding: 0px;">
                            <Button icon="pi pi-plus-circle" class="btn btn-primary m-3" label="Nueva" @click="crear" />
                            <DataTable :globalFilterFields="['nombre_serie', 'prefijo_factura_serie', 'prefijo_abono_serie']" :value="datos" datakey="nombe_serie" paginator v-model:filters="filters" 
                                :rows="15" :rowsPerPageOptions="[5, 10, 20, 50]">
                                <template #header>
                                    <div class="flex justify-content-between">
                                        <IconField iconPosition="left">
                                            
                                            <InputText style="visibility:visible" v-model="filters['global'].value" placeholder="Buscador" />
                                        </IconField>
                                    </div>
                                </template>
                                <Column  v-for="col in columnas" :key="col.field" :sortable="col.sortable" :filterField="col.field" filterMatchMode="contains" :field="col.field" :header="col.header">
                                    <template #body="slotProps" v-if="esColumnaPersonalizada(col)">      
                                        <botones-acciones  
                                            :acciones="mapearAcciones(col.acciones, slotProps.data)" 
                                            :nombredos="slotProps.data[col.field]"
                                            :datos="slotProps.data">
                                        </botones-acciones>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import LineasFacturacionEstados from './listado/LineasFacturacionEstados.vue'
import { PwgsApi } from '../../../services/PwgsApi';
import { FilterMatchMode } from 'primevue/api';
import BotonesAcciones from '../../BotonesAcciones.vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
export default {
    components: {
        'lineasfacturacion-estados': LineasFacturacionEstados,
        DataTable,Column,BotonesAcciones
    },
    props: {
        
        verifactu: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            isFiltering: false,
            tablaLista: false,
            no_factura: localStorage.getItem('no_factura'),
            sistema_verifactu: localStorage.getItem('sistema_verifactu'),
            total:'',
            activos: '',
            eliminados: '',
            datos: [],
            parametros: null, // query params de DataTable
            mostrareliminados: false,
            filters: {
                                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                'nombre_serie': { value:null, matchMode: FilterMatchMode.CONTAINS },
                'prefijo_factura_serie': { value:null, matchMode: FilterMatchMode.CONTAINS },
                'prefijo_abono_serie': { value:null, matchMode: FilterMatchMode.CONTAINS }, 
            },
            columnas: [
                {
                    header: 'Nombre',
                    field: 'nombre_serie',
                    sortable: true,
                },
                {
                    header: 'Prefijo Factura',
                    field: 'prefijo_factura_serie',
                    sortable: true,
                },
                {
                    header: 'Prefijo Abono',
                    field: 'prefijo_abono_serie',
                    sortable: true,
                },
                {
                    header: 'Actual',
                    field: 'siguiente_numero',
                },
                {
                    header: 'Actual rectificativa',
                    field: 'siguiente_numero_abono',
                },
                {
                    header: 'Dígitos',
                    field: 'digitos_numero_factura',
                },
                {
                    header: 'Inicio',
                    field: 'tope_serie',
                },
                {
                    header: 'Inicio rectificativa',
                    field: 'tope_serie_abono',
                },
                {
                    header: 'Acciones',
                    data: null,
                    acciones: [
                        {
                            nombre: 'Editar',
                            class: 'editar',
                            tipo: 'default',
                            nombreId: null,
                            icono: 'far fa-edit',
                            // Debe ser arrow function para que this sea este componente
                            accion: (datosFila) => {
                                this.$router.push({
                                    name: 'Línea Facturación',
                                    params: {
                                        id:datosFila.id
                                    }
                                });
                            }
                        },
                        {
                            nombre: 'Archivar',
                            class: 'eliminar',
                            tipo: 'warning',
                            nombreId: null,
                            icono: 'fas fa-archive',
                            // Debe ser arrow function para que this sea este componente
                            accion: (datosFila) => {
                                if (confirm(`Desea archivar la serie ${datosFila.nombre_serie} (${datosFila.prefijo_factura_serie})?`)) {
                                    this.eliminar(datosFila.id);
                                }
                            }
                        },
                        {
                            nombre: 'Recuperar',
                            class: 'eliminar d-none',
                            tipo: 'success',
                            nombreId: null,
                            icono: 'fas fa-undo',
                            // Debe ser arrow function para que this sea este componente
                            accion: (datosFila) => {
                                if (confirm(`Desea recuperar la serie ${datosFila.nombre_serie} (${datosFila.prefijo_factura_serie})?`)) {
                                    this.recuperar(datosFila.id);
                                }
                            }
                        },
                    ]
                }
            ],
        }
    },
    methods: {
        async obtenerDatos() {
            const api = new PwgsApi();
            //const inicio = performance.now();

            this.$store.dispatch('cambiarCargando', true);
            let aux = [];
            try {
                if(this.verifactu==1){
                    if(this.mostrareliminados){
                        aux = await api.get('lineas-facturacion/verifactu,eliminados');
                    }else{
                        aux = await api.get('lineas-facturacion/verifactu');
                        this.activos = aux.n_total_registros;
                    }
                    this.datos = aux.datos;

                }
                else {
                    if(this.mostrareliminados){
                        aux = await api.get('lineas-facturacion/eliminados');
                    }else{
                        aux = await api.get('lineas-facturacion');
                        this.activos = aux.n_total_registros;
                    }
                    this.datos = aux.datos;
                }
                setTimeout(() => {
                    this.actualizarEstiloColumnas();
                }, 100);
               
            } catch (error) {
                console.error('[DEBUG] Error al cargar los datos:', error);
               
            } finally {
                this.$store.dispatch('cambiarCargando', false);
                this.obtenereliminados();
            }
        },
        esColumnaPersonalizada(col) {
            return col.formato || col.acciones || col.componente;
        },
        crear() {
            var facturacion = (localStorage.getItem('no_factura') == 1 || localStorage.getItem('sistema_verifactu') == 1) ? 'Registro contable' : 'Facturación';
            if(this.$props.verifactu){
                facturacion = 'VeriFactu';
            }
            console.log("crear", "Línea " + facturacion);
            console.log("crear2", this.$props.verifactu);
            this.$router.push({ name: ("Línea " + facturacion), params: { id: 0, verifactu: this.$props.verifactu } });
        },
        async eliminar(id) {
            /* delete  modulos/pwgsapi/index.php/lineas-facturacion/:id */
            try {
                const api = new PwgsApi();
                await api.delete('lineas-facturacion/' + id);
                this.obtenerDatos();
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async recuperar(id) {
            if(id > 0 ){
                try{
                    const subidadatos = { estado_serie: 0 }
                    const api = new PwgsApi();
                    await api.put('lineas-facturacion/' + id, subidadatos);
                    this.obtenerDatos();
                }
                catch(error){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        async obtenereliminados() {
            const api = new PwgsApi();
            let aux = [];
            if(this.verifactu==1){
                aux = await api.get('/lineas-facturacion/verifactu,eliminados');
            }else{
                aux = await api.get('/lineas-facturacion/eliminados');
            }
            this.eliminados = aux.n_total_registros;
        },
        cambiaractivos(){
            this.mostrareliminados = false;
            /*this.columnas[7].acciones[1].class = 'eliminar';
            this.columnas[7].acciones[2].class = 'eliminar d-none';*/
            this.obtenerDatos(); 
        },
        cambiareliminados(){
            this.mostrareliminados = true;
            /*this.columnas[7].acciones[1].class = 'eliminar d-none';
            this.columnas[7].acciones[2].class = 'eliminar';*/
            this.obtenerDatos();
        },
        actualizarEstiloColumnas(){
            const colAcciones = this.columnas[8];
            if(this.mostrareliminados){
                colAcciones.acciones[1].class = 'eliminar d-none'; // Archivar
                colAcciones.acciones[2].class = 'eliminar';        // Recuperar
            }else{
                colAcciones.acciones[1].class = 'eliminar';        // Archivar
                colAcciones.acciones[2].class = 'eliminar d-none'; // Recuperar
            }
        },
        mapearAcciones(acciones, fila) {
            return acciones.map(accionOriginal => ({
                ...accionOriginal,
                accion: () => accionOriginal.accion(fila) 
            }));
        },
    },
    
    mounted() {
        this.obtenerDatos();
        const colAcciones = this.columnas.find(col => col.header === 'Acciones');
        const accionEditar = colAcciones.acciones.find(a => a.nombre === 'Editar');
        if(this.no_factura == 1 || this.sistema_verifactu == 1){
            this.columnas[1].header = this.$t("general.prefijoregistro");
            this.columnas[3].header = this.$t("general.siguiente_numero_registro");
            accionEditar.accion = (datosFila) => {
                this.$router.push({
                    name: 'Línea Registro contable',
                    params: { id:datosFila.id },
                });
            };
        }else{
            this.columnas[1].header = this.$t("general.prefijofactura");
            this.columnas[3].header = this.$t("general.siguiente_numero");
        }
        if(this.verifactu == 1){
            this.columnas[1].header = this.$t("general.prefijoverifactu");
            this.columnas[3].header = this.$t("general.siguiente_numero_verifactu");
            accionEditar.accion = (datosFila) => {
                this.$router.push({
                    name: 'Línea VeriFactu',
                    params: { id:datosFila.id,verifactu:1 },
                });
            };
        }
        this.columnas[0].header = this.$t("general.nombre");
        this.columnas[2].header = this.$t("general.prefijoabono");
        this.columnas[4].header = this.$t("general.siguiente_numero_abono");
        this.columnas[5].header = this.$t("general.digitos");
        this.columnas[6].header = this.$t("general.inicio");
        this.columnas[8].header = this.$t("general.acciones");
    },
 
    watch: {
        $route() {
            this.obtenerDatos();
            const colAcciones = this.columnas.find(col => col.header === 'Acciones');
            const accionEditar = colAcciones.acciones.find(a => a.nombre === 'Editar');
            if(this.no_factura == 1 || this.sistema_verifactu == 1){
                this.columnas[1].header = this.$t("general.prefijoregistro");
                this.columnas[3].header = this.$t("general.siguiente_numero_registro");
                accionEditar.accion = (datosFila) => {
                    this.$router.push({
                        name: 'Línea Registro contable',
                        params: { id:datosFila.id },
                    });
                };
            }else{
                this.columnas[1].header = this.$t("general.prefijofactura");
                this.columnas[3].header = this.$t("general.siguiente_numero");
            }
            if(this.verifactu == 1){
                this.columnas[1].header = this.$t("general.prefijoverifactu");
                this.columnas[3].header = this.$t("general.siguiente_numero_verifactu");
                accionEditar.accion = (datosFila) => {
                    this.$router.push({
                        name: 'Línea VeriFactu',
                        params: { id:datosFila.id,verifactu:1 },
                    });
                };
            }
            this.columnas[0].header = this.$t("general.nombre");
            this.columnas[2].header = this.$t("general.prefijoabono");
            this.columnas[4].header = this.$t("general.siguiente_numero_abono");
            this.columnas[5].header = this.$t("general.digitos");
            this.columnas[6].header = this.$t("general.inicio");
            this.columnas[8].header = this.$t("general.acciones");
        }
    }
}
</script>
<style scoped>
.p-dialog {
    width: 90%;
}
.p-datatable-header{
    visibility:visible !important;
}
</style>